import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.base.service';
import { environment } from '@env/environment.local';
import { Observable } from 'rxjs';
import { queryParamsDealers } from '../interfaces/models.interface';

@Injectable({
  providedIn: 'root'
})
export class DealerService {

  constructor(public api: ApiService) { }

  getAllDealers(data: queryParamsDealers): Observable<any> {
    //filtros
    return this.api.post(`${environment.API_DEALEARS_SERVICE}/dealers/all`, data);
  }

  getDealers(): Observable<any> {
    //filtros
    return this.api.get(`${environment.API_DEALEARS_SERVICE}/dealers/name`);
  }

  getDealersInStandarQuote(): Observable<any> {
    return this.api.get(`${environment.API_DEALEARS_SERVICE}/dealers`);
  }

  getDealerById(id: string): Observable<any> {
    //filtros
    return this.api.get(`${environment.API_DEALEARS_SERVICE}/dealers/${id}`);
  }

  createDealer(data: any): Observable<any> {
    return this.api.post(`${environment.API_DEALEARS_SERVICE}/dealers`, data);
  }

  updateDealer(id: string, data: any): Observable<any> {
    //filtros
    return this.api.put(`${environment.API_DEALEARS_SERVICE}/dealers/${id}`, data);
  }

  getGroups(): Observable<any> {
    return this.api.get(`${environment.API_DEALEARS_SERVICE}/groups`);
  }

  getBranchById(dealerId: string, branchId: string): Observable<any> {
    return this.api.get(`${environment.API_DEALEARS_SERVICE}/dealers/${dealerId}/branch/${branchId}`);
  }

  getBranchesByWholesaleId(wholesaleId: number): Observable<any> {
    return this.api.get(`${environment.API_DEALEARS_SERVICE}/dealers-branches-extended/by-wholesale/${wholesaleId}`);
  }

  createBranch(data: any): Observable<any> {
    return this.api.post(`${environment.API_DEALEARS_SERVICE}/dealers/${data.dealerId}/branch`, data);
  }

  updateBranch(dealerId: string, branchId: string, data: any): Observable<any> {
    return this.api.put(`${environment.API_DEALEARS_SERVICE}/dealers/${dealerId}/branch/${branchId}`, data);
  }

  getWholesalesByDealerId(dealerId: string): Observable<any> {
    return this.api.get(`${environment.API_WHOLESALE_SERVICE}/wholesales/dealers/${dealerId}`);
  }

  getWholesaleById(wholesaleId: number): Observable<any> {
    return this.api.get(`${environment.API_WHOLESALE_SERVICE}/wholesales/${wholesaleId}`);
  }

  wholesaleApi(data: any): Observable<any> {
    return this.api.post(`${environment.API_WHOLESALE_SERVICE}/wholesales`, data);
  }

  getWholeSales(): Observable<any> {
    return this.api.get(`${environment.API_WHOLESALE_SERVICE}/wholesales`);
  }

  getWholeSaleByKey(key: string): Observable<any> {
    return this.api.get(`${environment.API_WHOLESALE_SERVICE}/wholesales/keys/${key}`);
  }

  getStatesAndPostalCodes(): Observable<any> {
    return this.api.get(`${environment.API_QUOTE_SERVICE}/states/list`);
  }

  sendfinancialLinkInvitation(dealerId: string, data: any): Observable<any> {
    return this.api.post(`${environment.API_DEALEARS_SERVICE}/dealers/${dealerId}/link-invitation`, data);
  }

  deleteFinancialLinkInvitation(invitationId: string): Observable<any> {
    return this.api.delete(`${environment.API_DEALEARS_SERVICE}/dealers/link-invitation/${invitationId}`, false);
  }
}
